const sentryEventIds = new WeakMap<object, string>()

export function getSentryEventId(error: unknown) {
  if (typeof error !== 'object' || error === null) {
    return undefined
  }

  return sentryEventIds.get(error)
}

export function setSentryEventId(error: unknown, eventId: string) {
  if (typeof error !== 'object' || error === null) {
    return
  }

  sentryEventIds.set(error, eventId)
}
